import ArrivalScreen from '../screens/ArrivalScreen';

export const TextDisplayView = (props) => {
  const { text, clickButton } = props;
  return <ArrivalScreen mainText={text} clickButton={clickButton} showButton={true} textDisplayMode={true} />;
};
